import GearView from './gear-view'

export default GearView
